import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "./ducks/auth.duck";
import * as flags from "./ducks/flags.duck";
import { metronic } from "../../_metronic";

import breadcrumbReducer from "./reducers/breadcrumbReducer";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  builder: metronic.builder.reducer,
  flags: flags.reducer,
  breadcrumb: breadcrumbReducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
